const observedHeroes = new WeakSet();

function updatePreservedComposition(hero, width) {
  hero.querySelectorAll('[data-ptt-preserved]').forEach((composition) => {
    const mobile = width < 1024 && Number(composition.dataset.pttMobileWidth) > 0;
    const sourceWidth = Number(mobile ? composition.dataset.pttMobileWidth : composition.dataset.pttDesktopWidth);
    const sourceHeight = Number(mobile ? composition.dataset.pttMobileHeight : composition.dataset.pttDesktopHeight);
    const rectangle = mobile ? composition.dataset.pttMobileCrop.split(' ').map(Number) : [0, 0, sourceWidth, sourceHeight];
    if (!rectangle.every(Number.isFinite)) return;
    composition.dataset.pttComposition = mobile ? 'mobile' : 'desktop';
    composition.dataset.pttSubjectBounds = mobile ? '225,930,790,320' : '1172,438,1844,719';
    composition.dataset.pttCrop = rectangle.join(',');
    composition.dataset.pttSourceWidth = String(sourceWidth);
    composition.dataset.pttSourceHeight = String(sourceHeight);
    const cropWindow = composition.querySelector('.ptt-scene__preserved-window');
    const scale = cropWindow.getBoundingClientRect().width / rectangle[2];
    const portrait = composition.querySelector('[data-ptt-preserved-mobile]');
    if (portrait) {
      portrait.media = mobile ? 'all' : 'not all';
      portrait.sizes = `${Math.ceil(rectangle[2] * scale * sourceWidth / rectangle[2])}px`;
    }
  });
}

function mountLayeredHeroes(scope = document) {
  const heroes = [...scope.querySelectorAll('.ptt-layered-hero')];
  if (scope.matches?.('.ptt-layered-hero')) heroes.unshift(scope);
  heroes.forEach((hero) => {
    if (observedHeroes.has(hero)) return;
    observedHeroes.add(hero);
    const slider = hero.querySelector('.slideshow');
    let previousWidth = 0;
    let frame;
    const observer = new ResizeObserver(() => {
      const width = hero.getBoundingClientRect().width;
      if (!width) return;
      updatePreservedComposition(hero, width);
      if (Math.abs(width - previousWidth) < 0.5) return;
      previousWidth = width;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const active = slider?.querySelector('.slideshow__slide.is-active');
        if (active) slider.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
      });
    });
    updatePreservedComposition(hero, hero.getBoundingClientRect().width);
    observer.observe(hero);
    hero.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    }, { once: true });
  });
}

mountLayeredHeroes();
document.addEventListener('shopify:section:load', (event) => mountLayeredHeroes(event.target));
